import { useEffect, useState } from 'react'
import loadYandexMapsApi from 'utils/loadYandexMapsApi'

const YANDEX_MAPS_API_KEY = process.env.REACT_APP_YANDEX_MAPS_API_KEY

const useYandexMapsApi = () => {
  const [isReady, setIsReady] = useState(!!window.ymaps)

  useEffect(() => {
    if (isReady) return undefined

    let isMounted = true

    loadYandexMapsApi(YANDEX_MAPS_API_KEY).then(() => {
      if (isMounted) setIsReady(true)
    })

    return () => {
      isMounted = false
    }
  }, [isReady])

  return isReady
}

export default useYandexMapsApi
